import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import TeamCard from "@/components/ui/team-card";

const teamMembers = [
  {
    name: "Sarah Johnson",
    title: "Personal Insurance Specialist",
    description:
      "With over 10 years of experience in personal insurance, Sarah helps clients find the perfect coverage for their homes and vehicles.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "sarah@axentbrokers.com",
    phone: "+15551234567",
  },
  {
    name: "David Martinez",
    title: "Commercial Insurance Advisor",
    description:
      "David specializes in business insurance solutions, helping companies manage risk and protect their assets.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "david@axentbrokers.com",
    phone: "+15551234568",
  },
  {
    name: "Michelle Wong",
    title: "Life & Health Insurance Expert",
    description:
      "Michelle helps individuals and families find the right health and life insurance coverage for their unique situations.",
    image: "https://images.unsplash.com/photo-1573496358961-3c82861ab8f4?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "michelle@axentbrokers.com",
    phone: "+15551234569",
  },
  {
    name: "Robert Thompson",
    title: "Senior Insurance Advisor",
    description:
      "With 20+ years in the industry, Robert provides expert guidance on complex insurance portfolios for high-net-worth clients.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "robert@axentbrokers.com",
    phone: "+15551234570",
  },
  {
    name: "Jennifer Lee",
    title: "Auto Insurance Specialist",
    description:
      "Jennifer specializes in finding the best auto insurance coverage options to protect drivers and their vehicles.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "jennifer@axentbrokers.com",
    phone: "+15551234571",
  },
  {
    name: "Michael Rodriguez",
    title: "Claims Specialist",
    description:
      "Michael helps clients navigate the claims process, ensuring they receive the full benefits they're entitled to under their policies.",
    image: "https://images.unsplash.com/photo-1563237023-b1e970526dcb?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "michael@axentbrokers.com",
    phone: "+15551234572",
  },
  {
    name: "Lisa Williams",
    title: "Home Insurance Advisor",
    description:
      "Lisa specializes in homeowners and renters insurance, helping clients protect their properties and belongings.",
    image: "https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "lisa@axentbrokers.com",
    phone: "+15551234573",
  },
  {
    name: "James Wilson",
    title: "Risk Management Specialist",
    description:
      "James helps businesses identify potential risks and develop comprehensive insurance strategies to mitigate them.",
    image: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "james@axentbrokers.com",
    phone: "+15551234574",
  },
  {
    name: "Patricia Garcia",
    title: "Medicare Specialist",
    description:
      "Patricia helps seniors navigate the complexities of Medicare and supplemental insurance options for retirement planning.",
    image: "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
    linkedin: "#",
    email: "patricia@axentbrokers.com",
    phone: "+15551234575",
  }
];

const Team = () => {
  return (
    <>
      <section className="bg-primary py-20 px-4">
        <div className="max-w-7xl mx-auto text-center text-white">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6">Our Team</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Meet our dedicated insurance specialists who are committed to finding the best coverage for your clients' needs.
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-4">Insurance Specialists You Can Trust</h2>
            <p className="text-lg text-neutral-800 max-w-3xl mx-auto">
              Our team of experienced insurance professionals is dedicated to providing personalized service and expert guidance for all your clients' insurance needs.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <TeamCard
                key={index}
                name={member.name}
                title={member.title}
                description={member.description}
                image={member.image}
                linkedin={member.linkedin}
                email={member.email}
                phone={member.phone}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-secondary py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-6">Join Our Team</h2>
              <p className="text-lg mb-6">
                Are you passionate about helping people protect what matters most to them? We're always looking for talented individuals to join our team of insurance professionals.
              </p>
              <p className="text-lg mb-6">
                At Axent Brokers, we foster a collaborative environment where you can grow your career while making a meaningful difference in our clients' lives. We offer competitive compensation, ongoing professional development, and a supportive team culture.
              </p>
              <div className="mt-8">
                <Link href="/careers">
                  <Button>View Open Positions</Button>
                </Link>
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <div 
                className="rounded-lg shadow-lg h-80 bg-cover bg-center"
                style={{ backgroundImage: "url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80')" }}
                role="img"
                aria-label="Team collaboration meeting"
              ></div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-primary py-16 px-4">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="text-3xl font-heading font-semibold mb-6">Ready to Work With Our Team?</h2>
          <p className="text-xl mb-8">
            Contact us today to speak with one of our insurance specialists about your clients' coverage needs.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link href="/#quote-form">
              <Button variant="outline" className="bg-white text-primary hover:bg-neutral-100">
                Get a Free Quote
              </Button>
            </Link>
            <Link href="/contact">
              <Button variant="outline" className="border-white text-white hover:bg-white/10">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Team;
